import React from "react";
import {
  Box,
  BoxProps,
  StatusIndicator,
  StatusIndicatorProps,
} from "@amzn/awsui-components-react-v3/polaris";

const statusTypeToColor: Record<
  NonNullable<StatusIndicatorProps.Type>,
  BoxProps.Color
> = {
  error: "text-status-error",
  warning: "text-status-warning",
  success: "text-status-success",
  info: "text-status-info",
  stopped: "text-status-inactive",
  pending: "text-status-inactive",
  loading: "text-status-inactive",
  log: "text-status-inactive",
  "in-progress": "text-status-inactive",
  "not-started": "text-status-inactive",
};

/**
 * Splits the Cloudscape StatusIndicator component from its children and wraps
 * both in a Box component so that multi-line text wraps at word boundaries
 * instead of being constrained by the inline layout of StatusIndicator.
 */
export const BlockStatusIndicator = ({
  type = "success",
  children,
}: StatusIndicatorProps) => (
  <Box color={statusTypeToColor[type]}>
    <StatusIndicator type={type} />
    {children}
  </Box>
);
